import React from 'react';

const IconCancel = () => {
	return <i className="fa-solid fa-ban text-base text-primary"></i>;
};

export default IconCancel;